
import Honorary from '@/components/about/Honorary'
import Development from '@/components/about/Development'
import Culture from '@/components/about/Culture'
import Responsibility from '@/components/about/Responsibility'
import AboutLingBangTechnology from '@/components/about/AboutLingBangTechnology'
export default {
  name: 'About',
  data() {
    return {
      activeName: '关于我们',
      activeIndex: 0,
      topData: []
    }
  },
  props: {
    scrollTop: {
      type: Number,
      default: 0
    },
    menuIndex: {
      type: String,
      default: '/about'
    }
  },
  inject: ['menuActive'],
  watch: {
    menuActive: {
      handler (value) {
        const menuIndex = value.value
        if (!menuIndex.includes('/about')) {
          return false
        }
        let id = menuIndex.includes('?id=') ? menuIndex.split('?id=')[1] - 0 : 0
        id = id > 5 ? 0 : id
        if (this.topData.length > 0) {
          this.goTo('section' + id, id)
          this.activeIndex = id
        }
      },
      immediate: false,
      deep: true
    },
    scrollTop() {
      for (let i = 0; i < this.topData.length; i++) {
        if (this.scrollTop >= this.topData[i]) {
          this.activeIndex = 6 - 1 - i
          this.$router.push({query: {id: this.activeIndex}})
          return true
        }
      }
    }
  },
  created() {
  },
  mounted() {
    const query = this.getQuery()
    if (query) {
      const offsetTop = document.getElementById('section' + query).offsetTop - 132
      document.querySelector('.scroll-wrap').scrollTo(0, offsetTop)
      this.activeIndex = query
    }
    this.$nextTick(() => {
      const topArr = []
      for (let i = 5; i >= 0; i--) {
        topArr.push(document.getElementById('section' + i).offsetTop - 132 - 10)
      }
      this.topData = topArr
    })
  },
  methods: {
    goTo(id) {
      const num = id.substr(id.length-1, 1) - 0
      this.handleScroll(id, num)
      this.$router.push({query: {id: num}})
      this.activeIndex = num
    },
    handleScroll(id, num) {
      let offsetTop = document.getElementById(id).offsetTop - 132
      if (num === 0) {
        offsetTop = 0
      }
      document.querySelector('.scroll-wrap').scrollTo({
        top: offsetTop, //滚动高度
        behavior: 'smooth' // 平滑滚动
      })
    },
    getQuery() {
      let query = this.$route.query['id'] - 0
      if (query > 5) {
        query = 0
      }
      return query
    }
  },
  components: {
    Honorary,
    Development,
    Culture,
    Responsibility,
    AboutLingBangTechnology
  }
}
